import { operate } from '../util/lift';
import { createFind } from './find';
export function findIndex(predicate) {
    return operate(createFind(predicate, 'index'));
}
//# sourceMappingURL=findIndex.js.map